msgid ""
msgstr ""
"POT-Creation-Date: 2024-06-14 17:14-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:58
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:332
#: packages/webapp/src/analytics/account/Billing/constants.ts:18
#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/utils.ts:23
#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:94
#: packages/webapp/src/common/constants/billing.ts:23
msgid ""
msgstr "/+Z5u4"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:199
msgid ", including playback."
msgstr ", including playback."

#: packages/webapp/src/analytics/components/PlanLink.tsx:94
msgid "..."
msgstr "..."

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:199
msgid "(no playback)."
msgstr "(no playback)."

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:151
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:162
#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:139
#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:148
msgid "{0, plural, one {# {1}} other {# {2}}}"
msgstr "{0, plural, one {# {1}} other {# {2}}}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:140
msgid "{0, plural, one {# additional license is} other {# additional licenses are}} scheduled to be removed at the end of this billing period."
msgstr "{0, plural, one {# additional license is} other {# additional licenses are}} scheduled to be removed at the end of this billing period."

#: packages/webapp/src/analytics/MeetingReports/components/SearchResult/SearchResult.tsx:193
msgid "{0, plural, one {# instance} other {# instances}}"
msgstr "{0, plural, one {# instance} other {# instances}}"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:107
msgid "{0, plural, one {# participant} other {# participants}}"
msgstr "{0, plural, one {# participant} other {# participants}}"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:103
msgid "{0, plural, one {license} other {licenses}}"
msgstr "{0, plural, one {license} other {licenses}}"

#: packages/webapp/src/analytics/MeetingReports/components/SearchResult/SearchResult.tsx:186
msgid "{0} (owner)"
msgstr "{0} (owner)"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:175
msgid "{0} / month"
msgstr "{0} / month"

#: packages/webapp/src/analytics/account/Billing/utils.ts:138
msgid "{0} ending in {1}"
msgstr "{0} ending in {1}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:74
msgid "{0} features will continue to be available through the end of your current billing term, {expirationDate}."
msgstr "{0} features will continue to be available through the end of your current billing term, {expirationDate}."

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:62
msgid "{0} meeting"
msgstr "{0} meeting"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:25
msgid "{0} meeting reports per month"
msgstr "{0} meeting reports per month"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:48
msgid "{0} meeting reports per month."
msgstr "{0} meeting reports per month."

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:63
msgid "{0} meetings"
msgstr "{0} meetings"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:88
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:115
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:138
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:161
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:187
msgid "{0} minutes per month"
msgstr "{0} minutes per month"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:123
msgid "{0} of {1, plural, one {# license is} other {# licenses are}} in use"
msgstr "{0} of {1, plural, one {# license is} other {# licenses are}} in use"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:157
msgid "{0} Plan {1}"
msgstr "{0} Plan {1}"

#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/ReportExpirationBanner.tsx:77
msgid "{0} quota exceeded:"
msgstr "{0} quota exceeded:"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:264
msgid "{0} x {numLicensesAfterRemoval, plural, one {# license} other {# licenses}} x 1 {1}"
msgstr "{0} x {numLicensesAfterRemoval, plural, one {# license} other {# licenses}} x 1 {1}"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:144
msgid "{0}-minute"
msgstr "{0}-minute"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:51
msgid "{0}'s reports"
msgstr "{0}'s reports"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:222
msgid "{0}Daily Read"
msgstr "{0}Daily Read"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:105
msgid "{count, plural, one {# {0}} other {# {1}}}"
msgstr "{count, plural, one {# {0}} other {# {1}}}"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/TopicReportHeader.tsx:63
msgid "{count, plural, one {from # {0}} other {from # {1}}}"
msgstr "{count, plural, one {from # {0}} other {from # {1}}}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:93
msgid "{remainingMonthlyCredits, plural, one {# minute} other {# minutes}}"
msgstr "{remainingMonthlyCredits, plural, one {# minute} other {# minutes}}"

#: packages/webapp/src/analytics/ReportFileDownload/FileDownload.tsx:50
msgid "{title} downloaded!"
msgstr "{title} downloaded!"

#: packages/webapp/src/analytics/components/ExtendTrialOfferWall/ExtendTrialOfferWall.tsx:260
msgid "{totalTrialDays} days free, then {0} +tax billed {1}. Cancel anytime."
msgstr "{totalTrialDays} days free, then {0} +tax billed {1}. Cancel anytime."

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:133
msgid "* Billed annually"
msgstr "* Billed annually"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:78
msgid "<= 30 min"
msgstr "<= 30 min"

#: packages/webapp/src/analytics/components/TablePaginator/TablePaginator.tsx:66
msgid "<0>{firstItemNumber}—{lastItemNumber}</0> of {numItems}"
msgstr "<0>{firstItemNumber}—{lastItemNumber}</0> of {numItems}"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/ReportViewSelector.tsx:56
msgid "<0>Connect integrations</0> to get started with Email and Messaging reports, which are generated when new topics are detected across {providerList}."
msgstr "<0>Connect integrations</0> to get started with Email and Messaging reports, which are generated when new topics are detected across {providerList}."

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:126
msgid "<0>EDU + Video Plan:</0> Enjoy audio and video playback with highlights for only $8.33/month*"
msgstr "<0>EDU + Video Plan:</0> Enjoy audio and video playback with highlights for only $8.33/month*"

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:120
msgid "<0>EDU Plan:</0> Unlimited meetings and transcription for just $5/month"
msgstr "<0>EDU Plan:</0> Unlimited meetings and transcription for just $5/month"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/EDUBanners.tsx:39
msgid "<0>Education Plan Required:</0> To access EDU plans, please sign up for Read using a verified .edu email address or <1>update your primary email address</1>."
msgstr "<0>Education Plan Required:</0> To access EDU plans, please sign up for Read using a verified .edu email address or <1>update your primary email address</1>."

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/EDUBanners.tsx:70
msgid "<0>Email Verification Required:</0> To access EDU plans, please verify your email address. Once you’ve verified, refresh this page."
msgstr "<0>Email Verification Required:</0> To access EDU plans, please verify your email address. Once you’ve verified, refresh this page."

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:118
msgid "<0>Go to </0>Dashboard"
msgstr "<0>Go to </0>Dashboard"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseMaximumAlert.tsx:57
msgid "<0>License maximum reached:</0> Your {0} Plan is at the maximum of {1} licenses. Upgrade to Read Pro or Enterprise to purchase more licenses."
msgstr "<0>License maximum reached:</0> Your {0} Plan is at the maximum of {1} licenses. Upgrade to Read Pro or Enterprise to purchase more licenses."

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseMaximumAlert.tsx:62
msgid "<0>See the benefits of upgrading</0>."
msgstr "<0>See the benefits of upgrading</0>."

#: packages/webapp/src/analytics/MeetingReports/components/SearchResult/SearchResult.tsx:204
msgid "<0>Summary:</0> {0}"
msgstr "<0>Summary:</0> {0}"

#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/RecordingCappedBanner.tsx:34
msgid "<0>Upgrade your account</0> to measure meetings longer than {recordingMinutes} minutes."
msgstr "<0>Upgrade your account</0> to measure meetings longer than {recordingMinutes} minutes."

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:119
msgid "<0>Upgrade your plan</0> to get free monthly upload credits"
msgstr "<0>Upgrade your plan</0> to get free monthly upload credits"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:80
msgid "> 60 min"
msgstr "> 60 min"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:231
msgid "✨ beta"
msgstr "✨ beta"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:83
msgid "🎧 Daily Read"
msgstr "🎧 Daily Read"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:84
msgid "1:1 meeting"
msgstr "1:1 meeting"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:85
msgid "3-6 people"
msgstr "3-6 people"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:79
msgid "30-60 min"
msgstr "30-60 min"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:86
msgid "7+ people"
msgstr "7+ people"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:197
msgid "A password reset link has been sent to your email. Click the magic link in email to update password"
msgstr "A password reset link has been sent to your email. Click the magic link in email to update password"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:171
msgid "A verification email has been sent to {newEmail}. Click the magic link in the confirmation email to verify your email address"
msgstr "A verification email has been sent to {newEmail}. Click the magic link in the confirmation email to verify your email address"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:55
msgid "Access this Meeting Report"
msgstr "Access this Meeting Report"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:34
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:57
msgid "Access to recommendations and coaching"
msgstr "Access to recommendations and coaching"

#: packages/webapp/src/analytics/account/UserPreferences/UserPreferences.tsx:50
#: packages/webapp/src/analytics/components/UserNavMenu.tsx:87
msgid "Account Settings"
msgstr "Account Settings"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:423
#: packages/webapp/src/analytics/MeetingReport/MeetingReportHeader/ExternalShareMenu/PushDialogItem.tsx:41
#: packages/webapp/src/analytics/MeetingReport/MeetingReportHeader/ExternalShareMenu/PushMenuItem.tsx:43
msgid "Add"
msgstr "Add"

#: packages/webapp/src/analytics/account/components/FreeTrialAlert.tsx:100
msgid "Add a payment method to avoid losing access to {0} features once your trial ends"
msgstr "Add a payment method to avoid losing access to {0} features once your trial ends"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:168
msgid "Add licenses"
msgstr "Add licenses"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:75
msgid "Add payment method"
msgstr "Add payment method"

#: packages/webapp/src/analytics/account/components/FreeTrialAlert.tsx:87
msgid "Add Payment Method"
msgstr "Add Payment Method"

#: packages/webapp/src/analytics/components/SideNav/CreateWorkspaceLink.tsx:16
#: packages/webapp/src/analytics/components/UserNavMenu.tsx:116
msgid "Add People"
msgstr "Add People"

#: packages/webapp/src/analytics/DailyRead/styles.tsx:105
#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ForYouTeaser.tsx:69
msgid "Add Read"
msgstr "Add Read"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ForYouTeaser.tsx:80
msgid "Add Read to a meeting to start building your For You Page with key topics, action items, and questions!"
msgstr "Add Read to a meeting to start building your For You Page with key topics, action items, and questions!"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:93
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:106
msgid "Add Read to an upcoming meeting to start seeing reports."
msgstr "Add Read to an upcoming meeting to start seeing reports."

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:182
msgid "Add to live meeting"
msgstr "Add to live meeting"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:172
msgid "Added security for authentication"
msgstr "Added security for authentication"

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:140
msgid "Adding Read..."
msgstr "Adding Read..."

#: packages/webapp/src/analytics/account/UserPreferences/CustomVocabularyModule.tsx:38
#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/CustomVocabularyModule.tsx:48
msgid "Adding words to your custom vocabulary helps boost recognition in the transcript. This improves accuracy for names, product terms, and jargon."
msgstr "Adding words to your custom vocabulary helps boost recognition in the transcript. This improves accuracy for names, product terms, and jargon."

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:76
msgid "Admin"
msgstr "Admin"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:76
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:103
msgid "Admin control and team reporting"
msgstr "Admin control and team reporting"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:62
msgid "Advanced ({0} Required)"
msgstr "Advanced ({0} Required)"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:80
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:107
msgid "Advanced For You reporting with topic progression across meetings"
msgstr "Advanced For You reporting with topic progression across meetings"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:16
msgid "Advanced meeting metrics"
msgstr "Advanced meeting metrics"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:95
msgid "Advanced reporting"
msgstr "Advanced reporting"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteMeetingReportsEmptyState.tsx:43
msgid "All clear"
msgstr "All clear"

#: packages/webapp/src/analytics/components/RollupFilter/utils.ts:40
msgid "All teams"
msgstr "All teams"

#: packages/webapp/src/analytics/components/RollupFilter/utils.ts:35
msgid "All users"
msgstr "All users"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:105
#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:122
msgid "Analyzed {0, plural, one {# {1}} other {# {2}}}"
msgstr "Analyzed {0, plural, one {# {1}} other {# {2}}}"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/utils.ts:15
msgid "Analyzing {0} for crucial insights..."
msgstr "Analyzing {0} for crucial insights..."

#: packages/webapp/src/analytics/account/Billing/constants.ts:36
msgid "Annual"
msgstr "Annual"

#: packages/webapp/src/analytics/account/Billing/utils.ts:351
msgid "annually"
msgstr "annually"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:175
msgid "Annually"
msgstr "Annually"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:126
msgid "Any duration"
msgstr "Any duration"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:141
msgid "Apps & Integrations"
msgstr "Apps & Integrations"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:48
msgid "Are you sure?"
msgstr "Are you sure?"

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:113
msgid "As a Read user with a .edu email, we’re thrilled to offer you exclusive education pricing. Upgrade now to unlock academic excellence!"
msgstr "As a Read user with a .edu email, we’re thrilled to offer you exclusive education pricing. Upgrade now to unlock academic excellence!"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:126
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:149
msgid "Audio & video recordings with chapter annotations and more"
msgstr "Audio & video recordings with chapter annotations and more"

#: packages/webapp/src/analytics/account/Billing/utils.ts:409
msgid "Auto renews {formattedRenewalDate}"
msgstr "Auto renews {formattedRenewalDate}"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/TagFilterMenu.tsx:107
msgid "Auto Tags"
msgstr "Auto Tags"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:64
msgid "Automatic meeting summaries"
msgstr "Automatic meeting summaries"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:20
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:43
msgid "Basic meeting measurement, summaries, and reporting for better meetings. Limited to {0} meetings per month."
msgstr "Basic meeting measurement, summaries, and reporting for better meetings. Limited to {0} meetings per month."

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:33
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:56
msgid "Basic reporting"
msgstr "Basic reporting"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:107
msgid "Benchmarks"
msgstr "Benchmarks"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:124
msgid "Billing History"
msgstr "Billing History"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:161
msgid "Buy upload credits"
msgstr "Buy upload credits"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:67
msgid "Calendar"
msgstr "Calendar"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CancelPlanButton.tsx:44
msgid "Cancel plan"
msgstr "Cancel plan"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:35
msgid "Cancelled"
msgstr "Cancelled"

#: packages/webapp/src/analytics/account/Billing/constants.ts:30
msgid "Card"
msgstr "Card"

#: packages/webapp/src/analytics/account/Billing/constants.ts:31
msgid "Cash App"
msgstr "Cash App"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:150
#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:77
msgid "Change plan"
msgstr "Change plan"

#: packages/webapp/src/analytics/constants/topics.ts:52
#: packages/webapp/src/analytics/constants/topics.ts:64
msgid "channel"
msgstr "channel"

#: packages/webapp/src/analytics/constants/topics.ts:53
#: packages/webapp/src/analytics/constants/topics.ts:65
msgid "channels"
msgstr "channels"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:279
msgid "Close"
msgstr "Close"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:93
msgid "Coaching"
msgstr "Coaching"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:73
#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:132
#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:139
msgid "Compare plans"
msgstr "Compare plans"

#: packages/webapp/src/analytics/components/DateSelector/DateSelector.tsx:209
msgid "Compare to previous period"
msgstr "Compare to previous period"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:28
msgid "Conference room detection"
msgstr "Conference room detection"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:174
msgid "Congrats on unlocking unlimited reports{0}! After this meeting, you'll get a full recap (expect a little extra time for this first report)."
msgstr "Congrats on unlocking unlimited reports{0}! After this meeting, you'll get a full recap (expect a little extra time for this first report)."

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:82
msgid "Contact support"
msgstr "Contact support"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:125
msgid "Continue without recording"
msgstr "Continue without recording"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:224
msgid "Contributors"
msgstr "Contributors"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:265
#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:100
msgid "Copied!"
msgstr "Copied!"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:100
msgid "Copy link"
msgstr "Copy link"

#: packages/webapp/src/analytics/auth/utils.tsx:37
#: packages/webapp/src/analytics/auth/utils.tsx:50
msgid "Could not create account"
msgstr "Could not create account"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:70
msgid "Create a free Read account to view this report"
msgstr "Create a free Read account to view this report"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:53
msgid "Create a password"
msgstr "Create a password"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:159
msgid "Create a Workspace"
msgstr "Create a Workspace"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:48
msgid "Create account"
msgstr "Create account"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:67
msgid "Create an account to join this Workspace"
msgstr "Create an account to join this Workspace"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:112
msgid "Create Workspace"
msgstr "Create Workspace"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/utils.ts:19
msgid "Creating your first Readout..."
msgstr "Creating your first Readout..."

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:117
msgid "Credits"
msgstr "Credits"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:121
msgid "Credits are applied when upgrading from one paid plan to another, to reflect the prorated amount."
msgstr "Credits are applied when upgrading from one paid plan to another, to reflect the prorated amount."

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:91
msgid "Current"
msgstr "Current"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:225
msgid "Current cost"
msgstr "Current cost"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:70
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:73
msgid "Current Plan"
msgstr "Current Plan"

#: packages/webapp/src/analytics/components/DateSelector/DateSelector.tsx:162
msgid "Custom"
msgstr "Custom"

#: packages/webapp/src/analytics/components/DateSelector/DateSelector.tsx:201
msgid "Custom date range"
msgstr "Custom date range"

#: packages/webapp/src/analytics/Calendar/Scheduling/Scheduling.tsx:54
msgid "Custom link created!"
msgstr "Custom link created!"

#: packages/webapp/src/analytics/Calendar/Scheduling/Scheduling.tsx:79
msgid "Custom link deleted!"
msgstr "Custom link deleted!"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/TagFilterMenu.tsx:117
msgid "Custom Tags"
msgstr "Custom Tags"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:84
#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/CustomVocabularyModule.tsx:35
msgid "Custom Vocabulary"
msgstr "Custom Vocabulary"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:41
msgid "Customize which meetings Read joins"
msgstr "Customize which meetings Read joins"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:179
msgid "Customized data deletion"
msgstr "Customized data deletion"

#: packages/webapp/src/analytics/components/SideNav/SideNavDailyRead.tsx:35
#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:51
msgid "Daily Read"
msgstr "Daily Read"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:35
msgid "Daily Summary"
msgstr "Daily Summary"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:151
msgid "Data cannot be reprocessed"
msgstr "Data cannot be reprocessed"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:178
msgid "Data retention policy"
msgstr "Data retention policy"

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResultSortMenu.tsx:28
msgid "Date (newest first)"
msgstr "Date (newest first)"

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResultSortMenu.tsx:33
msgid "Date (oldest first)"
msgstr "Date (oldest first)"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:47
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:34
msgid "Date & Time"
msgstr "Date & Time"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethodDetails.tsx:70
msgid "Default"
msgstr "Default"

#: packages/webapp/src/analytics/components/reports/DeleteMeetingReportConfirmationModal.tsx:19
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/cells/ReportActionsCell.tsx:105
msgid "Delete report"
msgstr "Delete report"

#: packages/webapp/src/analytics/components/reports/DeleteMeetingReportConfirmationModal.tsx:20
msgid "Delete Report?"
msgstr "Delete Report?"

#: packages/webapp/src/analytics/components/reports/DeleteMeetingReportConfirmationModal.tsx:24
msgid "Deleting this report means anyone with access will no longer be able to view it. This action is permanent and cannot be undone."
msgstr "Deleting this report means anyone with access will no longer be able to view it. This action is permanent and cannot be undone."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:273
msgid "Department"
msgstr "Department"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:44
msgid "Description"
msgstr "Description"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:64
#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportTableRow.tsx:65
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:159
msgid "Details"
msgstr "Details"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingReportProcessingRow.tsx:69
msgid "Details will be available once processing is complete"
msgstr "Details will be available once processing is complete"

#: packages/webapp/src/analytics/components/UpsellModule/UpsellModuleActions.tsx:45
#: packages/webapp/src/analytics/MeetingReports/Reports.tsx:178
msgid "Dismiss"
msgstr "Dismiss"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:175
msgid "Domain capture"
msgstr "Domain capture"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:49
msgid "Downgrade to Free"
msgstr "Downgrade to Free"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/ReportActionsMenu.tsx:118
msgid "Download"
msgstr "Download"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:42
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:329
#: packages/webapp/src/analytics/account/Billing/constants.ts:13
msgid "EDU"
msgstr "EDU"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:50
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:327
#: packages/webapp/src/analytics/account/Billing/constants.ts:15
msgid "EDU + Video"
msgstr "EDU + Video"

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:108
msgid "Education Plan Unlocked!"
msgstr "Education Plan Unlocked!"

#: packages/webapp/src/analytics/constants/topics.ts:80
#: packages/webapp/src/analytics/constants/topics.ts:84
#: packages/webapp/src/analytics/constants/topics.ts:91
#: packages/webapp/src/analytics/constants/topics.ts:95
msgid "email"
msgstr "email"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:90
msgid "Email"
msgstr "Email"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/ReportViewSelector.tsx:28
msgid "Email / Msg"
msgstr "Email / Msg"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/ReportViewSelector.tsx:42
msgid "Email and Messaging reports are generated when new topics are detected across your {providerList} <0>integrations</0>."
msgstr "Email and Messaging reports are generated when new topics are detected across your {providerList} <0>integrations</0>."

#: packages/webapp/src/analytics/constants/topics.ts:26
#: packages/webapp/src/analytics/constants/topics.ts:37
msgid "email thread"
msgstr "email thread"

#: packages/webapp/src/analytics/constants/topics.ts:27
#: packages/webapp/src/analytics/constants/topics.ts:38
msgid "email threads"
msgstr "email threads"

#: packages/webapp/src/analytics/constants/topics.ts:81
#: packages/webapp/src/analytics/constants/topics.ts:85
#: packages/webapp/src/analytics/constants/topics.ts:92
#: packages/webapp/src/analytics/constants/topics.ts:96
msgid "emails"
msgstr "emails"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:49
msgid "Enable automatic recording for Zoom"
msgstr "Enable automatic recording for Zoom"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:66
msgid "Enable local recording in Zoom settings to record this meeting"
msgstr "Enable local recording in Zoom settings to record this meeting"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:117
msgid "Enable Recording"
msgstr "Enable Recording"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:55
msgid "Enable Setting"
msgstr "Enable Setting"

#: packages/webapp/src/analytics/WorkspaceOverview/MeetingManager/MeetingManager.tsx:197
msgid "Engagement"
msgstr "Engagement"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:46
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:326
#: packages/webapp/src/analytics/account/Billing/constants.ts:16
#: packages/webapp/src/common/utils/__tests__/billingUtils.test.ts:53
#: packages/webapp/src/common/utils/__tests__/billingUtils.test.ts:74
msgid "Enterprise"
msgstr "Enterprise"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:168
msgid "Enterprise features, plus:"
msgstr "Enterprise features, plus:"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:54
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:325
#: packages/webapp/src/analytics/account/Billing/constants.ts:17
msgid "Enterprise+"
msgstr "Enterprise+"

#: packages/webapp/src/analytics/account/Billing/utils.ts:336
#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:38
msgid "Error"
msgstr "Error"

#: packages/webapp/src/analytics/components/PlanLink.tsx:113
msgid "Error loading plan"
msgstr "Error loading plan"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:59
#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/TopicReportHeader.tsx:187
msgid "Error updating report title. Please refresh the page or try again later."
msgstr "Error updating report title. Please refresh the page or try again later."

#: packages/webapp/src/analytics/account/Billing/constants.ts:12
msgid "Essential Apps via Zoom"
msgstr "Essential Apps via Zoom"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicReportProcessingRow.tsx:31
msgid "Est. processing time: 1 hr"
msgstr "Est. processing time: 1 hr"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:60
msgid "Expand any topic to get a deep dive. View a topic summary, relevant clips from your meetings, action items with statuses, and a Q&A"
msgstr "Expand any topic to get a deep dive. View a topic summary, relevant clips from your meetings, action items with statuses, and a Q&A"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethodDetails.tsx:75
msgid "Expires {0}/{1}"
msgstr "Expires {0}/{1}"

#: packages/webapp/src/analytics/account/Billing/utils.ts:340
msgid "Failed"
msgstr "Failed"

#: packages/webapp/src/analytics/components/SearchBar/SearchBar.tsx:190
msgid "Filtering by: {0}"
msgstr "Filtering by: {0}"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenuContainer.tsx:71
msgid "Filters"
msgstr "Filters"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:61
msgid "Fix"
msgstr "Fix"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:35
msgid "Folder"
msgstr "Folder"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:40
msgid "For additional security and control features, upgrade to {0}"
msgstr "For additional security and control features, upgrade to {0}"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:166
msgid "For organizations that require additional security, control, and support. Requires a Workspace and 10+ licenses."
msgstr "For organizations that require additional security, control, and support. Requires a Workspace and 10+ licenses."

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:145
msgid "For the next {0} days, you also have access to a <0>Read Enterprise</0> free trial! After {1} days, you can upgrade or continue to get premium features included in {2}."
msgstr "For the next {0} days, you also have access to a <0>Read Enterprise</0> free trial! After {1} days, you can upgrade or continue to get premium features included in {2}."

#: packages/webapp/src/analytics/components/SideNav/constants.ts:82
#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:28
msgid "For You"
msgstr "For You"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:30
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:331
#: packages/webapp/src/analytics/account/Billing/constants.ts:11
#: packages/webapp/src/common/utils/__tests__/billingUtils.test.ts:32
msgid "Free"
msgstr "Free"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:68
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:95
msgid "Free features, plus:"
msgstr "Free features, plus:"

#: packages/webapp/src/analytics/account/components/FreeTrialAlert.tsx:94
msgid "Free trial activated!"
msgstr "Free trial activated!"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:87
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:114
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:137
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:160
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:186
msgid "Free upload credits"
msgstr "Free upload credits"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:204
msgid "Free, no credit card required"
msgstr "Free, no credit card required"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:54
msgid "Generating {0} Readout"
msgstr "Generating {0} Readout"

#: packages/webapp/src/analytics/ReportFileDownload/FileDownload.tsx:41
msgid "Generating {title}..."
msgstr "Generating {title}..."

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:29
msgid "Get a 360-degree view of topics over time across your meetings, updated daily. Now available for all paid Read plans."
msgstr "Get a 360-degree view of topics over time across your meetings, updated daily. Now available for all paid Read plans."

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:59
msgid "Get a closer look"
msgstr "Get a closer look"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:63
msgid "Get a comprehensive understanding of every meeting with <0>Read Meeting Reports</0>. Understand what happened in the meeting, participant reactions, and how it could have been improved."
msgstr "Get a comprehensive understanding of every meeting with <0>Read Meeting Reports</0>. Understand what happened in the meeting, participant reactions, and how it could have been improved."

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:106
msgid "Get started by selecting a file to upload!"
msgstr "Get started by selecting a file to upload!"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:71
msgid "Get started with increased control & security"
msgstr "Get started with increased control & security"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:38
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:61
msgid "Get the free Calendar add-on"
msgstr "Get the free Calendar add-on"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:92
msgid "Get the most out of Read with Zoom's \"Recording\" notification"
msgstr "Get the most out of Read with Zoom's \"Recording\" notification"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:111
msgid "Get unlimited reports"
msgstr "Get unlimited reports"

#: packages/webapp/src/analytics/ReportFileDownload/FileDownload.tsx:35
msgid "Go to Report"
msgstr "Go to Report"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteMeetingReportsEmptyState.tsx:46
msgid "Good news! All of your meeting reports were processed as expected."
msgstr "Good news! All of your meeting reports were processed as expected."

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:314
#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:161
msgid "Got it"
msgstr "Got it"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/GroupReportsToggle.tsx:30
msgid "Group"
msgstr "Group"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/GroupReportsToggle.tsx:32
msgid "Group Recurring Meetings"
msgstr "Group Recurring Meetings"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:248
msgid "Hide transcript"
msgstr "Hide transcript"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:129
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:152
msgid "Highlight reels"
msgstr "Highlight reels"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:45
msgid "Home"
msgstr "Home"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/styles.tsx:71
msgid "Identified {0, plural, one {# action item} other {# action items}}"
msgstr "Identified {0, plural, one {# action item} other {# action items}}"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/styles.tsx:84
msgid "Identified {0, plural, one {# key question} other {# key questions}}"
msgstr "Identified {0, plural, one {# key question} other {# key questions}}"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/utils.ts:17
msgid "Identifying topics, action items, and Q&A..."
msgstr "Identifying topics, action items, and Q&A..."

#: packages/webapp/src/analytics/account/Billing/components/BillingLoadFailure.tsx:23
msgid "if the problem persists."
msgstr "if the problem persists."

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:204
msgid "If upgrading, a credit will be applied during checkout."
msgstr "If upgrading, a credit will be applied during checkout."

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:148
msgid "If you don't record, select Read {0} features will be unavailable for this meeting."
msgstr "If you don't record, select Read {0} features will be unavailable for this meeting."

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:56
msgid "Ignore"
msgstr "Ignore"

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:71
msgid "In the meantime, check out your <0>For You</0> page!"
msgstr "In the meantime, check out your <0>For You</0> page!"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:157
msgid "in your Workspace"
msgstr "in your Workspace"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/TopicReportHeader.tsx:270
msgid "Inactive"
msgstr "Inactive"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:70
#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:72
msgid "Incomplete"
msgstr "Incomplete"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:83
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:110
#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:46
msgid "Integrations"
msgstr "Integrations"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:205
msgid "Invoice"
msgstr "Invoice"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:55
msgid "Invoice Amount"
msgstr "Invoice Amount"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:39
msgid "Invoice Date"
msgstr "Invoice Date"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:101
msgid "Invoices will appear here as they become available"
msgstr "Invoices will appear here as they become available"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:59
msgid "Issue"
msgstr "Issue"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:267
msgid "Job title"
msgstr "Job title"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:54
msgid "Join a Workspace"
msgstr "Join a Workspace"

#: packages/webapp/src/analytics/components/RollupFilter/RollupFilter.tsx:218
msgid "Just me"
msgstr "Just me"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:51
msgid "Keep my {0} Plan"
msgstr "Keep my {0} Plan"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:22
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:45
msgid "Key features include:"
msgstr "Key features include:"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:211
msgid "Keywords"
msgstr "Keywords"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:36
msgid "Label"
msgstr "Label"

#: packages/webapp/src/analytics/components/LocaleSwitcher/LocaleMenuDialog.tsx:27
#: packages/webapp/src/analytics/components/UserNavMenu.tsx:137
msgid "Language"
msgstr "Language"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:19
msgid "Last 12 months"
msgstr "Last 12 months"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:15
msgid "Last 30 days"
msgstr "Last 30 days"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:18
msgid "Last 6 months"
msgstr "Last 6 months"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:16
msgid "Last 60 days"
msgstr "Last 60 days"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:14
msgid "Last 7 days"
msgstr "Last 7 days"

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:17
msgid "Last 90 days"
msgstr "Last 90 days"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/TopicReportHeader.tsx:255
msgid "Last updated: {0} {1}"
msgstr "Last updated: {0} {1}"

#: packages/webapp/src/analytics/components/RollupFilter/RollupFilter.tsx:238
msgid "Learn more about Workspaces"
msgstr "Learn more about Workspaces"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:104
msgid "License Usage"
msgstr "License Usage"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:99
msgid "Licenses"
msgstr "Licenses"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:239
msgid "Licenses removed{0}"
msgstr "Licenses removed{0}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:108
msgid "Licenses updated!"
msgstr "Licenses updated!"

#: packages/webapp/src/analytics/components/PlanLink.tsx:94
msgid "Loading plan..."
msgstr "Loading plan..."

#: packages/webapp/src/analytics/components/RollupFilter/RollupFilter.tsx:186
#: packages/webapp/src/analytics/components/RollupFilter/RollupFilterFree.tsx:47
#: packages/webapp/src/analytics/components/RollupFilter/utils.ts:25
msgid "Loading..."
msgstr "Loading..."

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:158
msgid "Log Out"
msgstr "Log Out"

#: packages/webapp/src/analytics/account/Billing/utils.ts:203
#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:211
msgid "Manage"
msgstr "Manage"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/CustomVocabularyModule.tsx:37
msgid "Manage custom words to boost accuracy in transcription across the Workspace"
msgstr "Manage custom words to boost accuracy in transcription across the Workspace"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:108
msgid "Manage people"
msgstr "Manage people"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:64
msgid "Manage SSO, domain capture, and data retention policy"
msgstr "Manage SSO, domain capture, and data retention policy"

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:105
msgid "Manage Workspace"
msgstr "Manage Workspace"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:44
msgid "Manually toggle Read on or off for any meeting in <0>your Calendar</0>, or adjust your <1>join preferences</1>in settings"
msgstr "Manually toggle Read on or off for any meeting in <0>your Calendar</0>, or adjust your <1>join preferences</1>in settings"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:52
msgid "Meeting Assistant"
msgstr "Meeting Assistant"

#: packages/webapp/src/analytics/WorkspaceOverview/MeetingManager/MeetingManager.tsx:128
msgid "Meeting Manager"
msgstr "Meeting Manager"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:125
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:148
msgid "Meeting playback"
msgstr "Meeting playback"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:91
msgid "Meeting playback + transcription"
msgstr "Meeting playback + transcription"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:115
msgid "Meeting Policy"
msgstr "Meeting Policy"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:184
msgid "Meeting Reports"
msgstr "Meeting Reports"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:18
msgid "Meeting transcription"
msgstr "Meeting transcription"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:47
#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/ReportViewSelector.tsx:24
#: packages/webapp/src/analytics/WorkspaceOverview/Participation/ParticipationTable.tsx:47
msgid "Meetings"
msgstr "Meetings"

#: packages/webapp/src/analytics/constants/topics.ts:106
#: packages/webapp/src/analytics/constants/topics.ts:117
msgid "message"
msgstr "message"

#: packages/webapp/src/analytics/constants/topics.ts:107
#: packages/webapp/src/analytics/constants/topics.ts:118
msgid "messages"
msgstr "messages"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:277
msgid "month"
msgstr "month"

#: packages/webapp/src/analytics/account/Billing/utils.ts:351
msgid "monthly"
msgstr "monthly"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:167
#: packages/webapp/src/analytics/account/Billing/constants.ts:35
msgid "Monthly"
msgstr "Monthly"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:76
msgid "Monthly <0>credits</0>"
msgstr "Monthly <0>credits</0>"

#: packages/webapp/src/analytics/MeetingReports/components/MoreResults/MoreResults.tsx:27
msgid "More results"
msgstr "More results"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/styles.tsx:15
msgid "Most Popular"
msgstr "Most Popular"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:49
msgid "My reports"
msgstr "My reports"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:235
msgid "Name"
msgstr "Name"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ForYouTeaser.tsx:48
msgid "New Topics Discovered"
msgstr "New Topics Discovered"

#: packages/webapp/src/common/components/FeatureBadge.tsx:31
msgid "NEW!"
msgstr "NEW!"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:140
#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:157
msgid "Next"
msgstr "Next"

#: packages/webapp/src/analytics/account/Billing/utils.ts:308
msgid "Next invoice {formattedPlanChangeDate}"
msgstr "Next invoice {formattedPlanChangeDate}"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:143
msgid "Next level note-taking with playback and highlight reels, allowing you to review discussions in detail."
msgstr "Next level note-taking with playback and highlight reels, allowing you to review discussions in detail."

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:53
msgid "No {0} Readout Generated"
msgstr "No {0} Readout Generated"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:183
msgid "No caps on meeting lengths"
msgstr "No caps on meeting lengths"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:228
msgid "No contributors"
msgstr "No contributors"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:150
msgid "No expiration"
msgstr "No expiration"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:215
msgid "No keywords"
msgstr "No keywords"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:351
msgid "No new Daily Read. Add Read to more meetings to generate a new Daily Read every day."
msgstr "No new Daily Read. Add Read to more meetings to generate a new Daily Read every day."

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:65
msgid "No payment method"
msgstr "No payment method"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:145
msgid "No recording"
msgstr "No recording"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteMeetingReportsEmptyState.tsx:34
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:78
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:105
msgid "No Reports"
msgstr "No Reports"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:84
msgid "No Reports {0}"
msgstr "No Reports {0}"

#: packages/webapp/src/analytics/ReportFileDownload/MeetingSummaryDownload.tsx:40
#: packages/webapp/src/analytics/ReportFileDownload/TopicSummaryDownload.tsx:45
msgid "No summary available"
msgstr "No summary available"

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:38
msgid "Not available"
msgstr "Not available"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:34
msgid "Not available {0}"
msgstr "Not available {0}"

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:145
msgid "Not Now"
msgstr "Not Now"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:285
#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:300
#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:315
msgid "Not provided"
msgstr "Not provided"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:17
msgid "Not seeing a recent meeting?"
msgstr "Not seeing a recent meeting?"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:195
msgid "Number of licenses to remove"
msgstr "Number of licenses to remove"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:29
msgid "On the {plan} plan, you get {allotment} minutes in free monthly credits. This resets on the first of each month."
msgstr "On the {plan} plan, you get {allotment} minutes in free monthly credits. This resets on the first of each month."

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:94
msgid "Once your video is uploaded, it will be processed and converted into a report."
msgstr "Once your video is uploaded, it will be processed and converted into a report."

#: packages/webapp/src/analytics/components/reports/DeleteMeetingReportConfirmationModal.tsx:31
#: packages/webapp/src/analytics/components/reports/RemoveMeetingReportConfirmationModal.tsx:31
msgid "Only report Owners can permanently delete reports"
msgstr "Only report Owners can permanently delete reports"

#: packages/webapp/src/analytics/ReportFileDownload/FileDownload.tsx:29
msgid "Oops! Something went wrong and the {title} could not be generated."
msgstr "Oops! Something went wrong and the {title} could not be generated."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:47
msgid "Oops! Something went wrong and your billing information could not be updated. Please confirm your billing details or try again later."
msgstr "Oops! Something went wrong and your billing information could not be updated. Please confirm your billing details or try again later."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:36
msgid "Oops! Something went wrong and your credits could not be applied to your account. Please confirm your billing details or try again later."
msgstr "Oops! Something went wrong and your credits could not be applied to your account. Please confirm your billing details or try again later."

#: packages/webapp/src/analytics/Calendar/Scheduling/Scheduling.tsx:58
msgid "Oops! Something went wrong and your link could not be created."
msgstr "Oops! Something went wrong and your link could not be created."

#: packages/webapp/src/analytics/Calendar/Scheduling/Scheduling.tsx:82
msgid "Oops! Something went wrong and your link could not be deleted."
msgstr "Oops! Something went wrong and your link could not be deleted."

#: packages/webapp/src/analytics/Calendar/Scheduling/Scheduling.tsx:71
msgid "Oops! Something went wrong and your link could not be updated."
msgstr "Oops! Something went wrong and your link could not be updated."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:25
msgid "Oops! Something went wrong and your Read plan could not be updated. Please confirm your billing details or try again later."
msgstr "Oops! Something went wrong and your Read plan could not be updated. Please confirm your billing details or try again later."

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:112
msgid "Oops! Something went wrong and your update could not be processed. Please refresh the page or try again later."
msgstr "Oops! Something went wrong and your update could not be processed. Please refresh the page or try again later."

#: packages/webapp/src/analytics/account/Billing/components/BillingLoadFailure.tsx:16
msgid "Oops! Something went wrong when trying to load your billing information. Please refresh the page or contact"
msgstr "Oops! Something went wrong when trying to load your billing information. Please refresh the page or contact"

#: packages/webapp/src/analytics/MeetingReports/components/ReportRowContextMenu.tsx:38
msgid "Open in new tab"
msgstr "Open in new tab"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:201
msgid "Open link"
msgstr "Open link"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:36
msgid "Opted out"
msgstr "Opted out"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:96
msgid "Other"
msgstr "Other"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:60
msgid "Outcome"
msgstr "Outcome"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:49
msgid "Owner"
msgstr "Owner"

#: packages/webapp/src/analytics/account/Billing/utils.ts:332
msgid "Paid"
msgstr "Paid"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportTableRow.tsx:97
msgid "Participant"
msgstr "Participant"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:99
msgid "Participant-level metrics"
msgstr "Participant-level metrics"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:17
msgid "Participant-level reporting"
msgstr "Participant-level reporting"

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:149
msgid "Paste meeting URL"
msgstr "Paste meeting URL"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:193
msgid "Pay Invoice"
msgstr "Pay Invoice"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:17
msgid "Payment failed. Please review your billing details or try again with a different payment method."
msgstr "Payment failed. Please review your billing details or try again with a different payment method."

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:138
msgid "payment method"
msgstr "payment method"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:126
msgid "Payment Method"
msgstr "Payment Method"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:109
msgid "Payment method removed"
msgstr "Payment method removed"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:22
msgid "Payment processing. Your Read plan will be upgraded when your payment completes."
msgstr "Payment processing. Your Read plan will be upgraded when your payment completes."

#: packages/webapp/src/analytics/account/Billing/utils.ts:344
msgid "Pending"
msgstr "Pending"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:119
msgid "plan"
msgstr "plan"

#: packages/webapp/src/analytics/account/Billing/Billing.tsx:73
#: packages/webapp/src/analytics/components/UserNavMenu.tsx:95
msgid "Plan & Billing"
msgstr "Plan & Billing"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:78
#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:129
msgid "plan details"
msgstr "plan details"

#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:74
msgid "Please contact Read support to set up {0} features such as SSO/SAML, domain capture, and data retention."
msgstr "Please contact Read support to set up {0} features such as SSO/SAML, domain capture, and data retention."

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:55
msgid "Please input a valid https URL"
msgstr "Please input a valid https URL"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:133
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:156
msgid "Premium support"
msgstr "Premium support"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:360
msgid "Primary Email"
msgstr "Primary Email"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:134
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:157
msgid "Priority access to our support team"
msgstr "Priority access to our support team"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:38
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:328
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.stories.tsx:31
#: packages/webapp/src/analytics/account/Billing/constants.ts:14
#: packages/webapp/src/analytics/components/RollupFilter/RollupFilterFree.tsx:62
#: packages/webapp/src/common/utils/__tests__/billingUtils.test.ts:108
msgid "Pro"
msgstr "Pro"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:122
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:145
msgid "Pro features, plus:"
msgstr "Pro features, plus:"

#: packages/webapp/src/analytics/MeetingReports/Reports.tsx:164
msgid "Processing reports"
msgstr "Processing reports"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:40
msgid "Profile & Account"
msgstr "Profile & Account"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:133
msgid "Purchased <0>credits</0>"
msgstr "Purchased <0>credits</0>"

#: packages/webapp/src/analytics/MeetingReport/MeetingReportHeader/ExternalShareMenu/ExternalShareNavMenu/ExternalShareNavMenu.tsx:94
#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/SendVia/SendViaMenuDialog.tsx:27
msgid "Push to..."
msgstr "Push to..."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:49
msgid "Quantity"
msgstr "Quantity"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:44
msgid "Quickly identify the themes of your work and the collaborators involved. View the main topics across your meetings, as well as topics you may have missed."
msgstr "Quickly identify the themes of your work and the collaborators involved. View the main topics across your meetings, as well as topics you may have missed."

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:150
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:155
msgid "Quota exceeded"
msgstr "Quota exceeded"

#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/ReportExpirationBanner.tsx:73
msgid "Quota exceeded:"
msgstr "Quota exceeded:"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/ReactivatePlanButton.tsx:42
msgid "Reactivate plan"
msgstr "Reactivate plan"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:82
msgid "Read {0}"
msgstr "Read {0}"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:36
msgid "Read automatically generates a high-level summary to recap what you've been working on, and also surfaces themes across your tags and Workspace."
msgstr "Read automatically generates a high-level summary to recap what you've been working on, and also surfaces themes across your tags and Workspace."

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:48
msgid "Read cannot automatically record"
msgstr "Read cannot automatically record"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:49
msgid "Read Dashboard is your hub for all reports and insights, including meeting trends over time and recommendations. Continue to discover how Read can improve your meeting wellness."
msgstr "Read Dashboard is your hub for all reports and insights, including meeting trends over time and recommendations. Continue to discover how Read can improve your meeting wellness."

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:104
msgid "Read has been added!"
msgstr "Read has been added!"

#: packages/webapp/src/analytics/WorkspaceOverview/components/HorizontalBarChart.tsx:90
msgid "Read Index"
msgstr "Read Index"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:39
#: packages/webapp/src/analytics/WorkspaceOverview/MeetingManager/MeetingManager.tsx:171
msgid "Read Score"
msgstr "Read Score"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:58
msgid "Reason"
msgstr "Reason"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:64
msgid "Reauthentication required to enable"
msgstr "Reauthentication required to enable"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:216
msgid "Receipt"
msgstr "Receipt"

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:214
msgid "Recommendation acknowledged"
msgstr "Recommendation acknowledged"

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:215
msgid "Recommendation applied"
msgstr "Recommendation applied"

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:238
msgid "Recommendation ignored"
msgstr "Recommendation ignored"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:104
msgid "Recommendations"
msgstr "Recommendations"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:58
msgid "Recording & Playback"
msgstr "Recording & Playback"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:153
msgid "Refresh"
msgstr "Refresh"

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResultSortMenu.tsx:23
msgid "Relevance"
msgstr "Relevance"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteMeetingReportsEmptyState.tsx:37
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:79
msgid "Remove filters to see your reports."
msgstr "Remove filters to see your reports."

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/LicenseUsage.tsx:182
#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:141
msgid "Remove licenses"
msgstr "Remove licenses"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:138
msgid "Remove Licenses"
msgstr "Remove Licenses"

#: packages/webapp/src/analytics/components/reports/RemoveMeetingReportConfirmationModal.tsx:19
#: packages/webapp/src/analytics/components/reports/RemoveTopicReportConfirmationModal.tsx:20
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/cells/ReportActionsCell.tsx:113
msgid "Remove report"
msgstr "Remove report"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/ReportActionsMenu.tsx:134
msgid "Remove Report"
msgstr "Remove Report"

#: packages/webapp/src/analytics/components/reports/RemoveMeetingReportConfirmationModal.tsx:20
#: packages/webapp/src/analytics/components/reports/RemoveTopicReportConfirmationModal.tsx:21
msgid "Remove Report?"
msgstr "Remove Report?"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:179
msgid "Removing licenses will only be reflected in the next billing period, and will not result in proration for the current billing period."
msgstr "Removing licenses will only be reflected in the next billing period, and will not result in proration for the current billing period."

#: packages/webapp/src/analytics/components/reports/RemoveMeetingReportConfirmationModal.tsx:24
msgid "Removing this report means it will no longer be shown in your list of Reports. This will not affect access for anyone else."
msgstr "Removing this report means it will no longer be shown in your list of Reports. This will not affect access for anyone else."

#: packages/webapp/src/analytics/components/reports/RemoveTopicReportConfirmationModal.tsx:25
msgid "Removing this report means you will no longer be able to view it. This action is permanent and cannot be undone."
msgstr "Removing this report means you will no longer be able to view it. This action is permanent and cannot be undone."

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/cells/ReportActionsCell.tsx:95
msgid "Rename report"
msgstr "Rename report"

#: packages/webapp/src/analytics/components/reports/RenameReportModal.tsx:31
#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/ReportActionsMenu.tsx:129
msgid "Rename Report"
msgstr "Rename Report"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:42
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:29
msgid "Report"
msgstr "Report"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:64
msgid "Report Access & Distribution"
msgstr "Report Access & Distribution"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportTableRow.tsx:96
msgid "Report owner"
msgstr "Report owner"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:56
#: packages/webapp/src/analytics/MeetingReports/MeetingReports.tsx:66
#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:52
msgid "Reports"
msgstr "Reports"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:20
msgid "Reports are typically available within 30 minutes after a meeting ends, but can take up to an hour for meetings exceeding 2 hours."
msgstr "Reports are typically available within 30 minutes after a meeting ends, but can take up to an hour for meetings exceeding 2 hours."

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/EDUBanners.tsx:78
msgid "Resend Verification"
msgstr "Resend Verification"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:421
msgid "Reset"
msgstr "Reset"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:107
msgid "Resets {monthlyCreditResetDate}"
msgstr "Resets {monthlyCreditResetDate}"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/DetailsModal.tsx:54
#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/incompleteReasonDetails.ts:37
msgid "Restricted Data"
msgstr "Restricted Data"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:130
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:153
msgid "Rewatch a 2-minute recap of the meeting's pivotal moments"
msgstr "Rewatch a 2-minute recap of the meeting's pivotal moments"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:66
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:93
msgid "Robust team metrics, admin control, and advanced reporting with unlimited meetings."
msgstr "Robust team metrics, admin control, and advanced reporting with unlimited meetings."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:270
msgid "Role level"
msgstr "Role level"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:134
msgid "Sales tax"
msgstr "Sales tax"

#: packages/webapp/src/analytics/components/reports/RenameReportModal.tsx:30
msgid "Save"
msgstr "Save"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:182
msgid "Save {annualSavings}%"
msgstr "Save {annualSavings}%"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:81
msgid "Schedule smarter with Read"
msgstr "Schedule smarter with Read"

#: packages/webapp/src/analytics/components/SearchBar/SearchBar.tsx:202
#: packages/webapp/src/analytics/MeetingReports/MeetingReports.tsx:66
msgid "Search"
msgstr "Search"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTableEmptyState.tsx:64
msgid "Search {0}"
msgstr "Search {0}"

#: packages/webapp/src/analytics/components/SearchBar/SearchBar.tsx:203
msgid "Search meetings..."
msgstr "Search meetings..."

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResults.tsx:47
msgid "Searching your meetings..."
msgstr "Searching your meetings..."

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:135
msgid "Select a date range"
msgstr "Select a date range"

#: packages/webapp/src/analytics/components/RollupFilter/utils.ts:30
msgid "Select a team"
msgstr "Select a team"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/SourceFilterMenu.tsx:79
msgid "Select all"
msgstr "Select all"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:146
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:92
msgid "Select plan"
msgstr "Select plan"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/ReportActionsMenu.tsx:122
msgid "Send via..."
msgstr "Send via..."

#: packages/webapp/src/analytics/WorkspaceOverview/MeetingManager/MeetingManager.tsx:184
msgid "Sentiment"
msgstr "Sentiment"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:267
msgid "Share link"
msgstr "Share link"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:173
msgid "Shared with {0, plural, one {# person} other {# people}}"
msgstr "Shared with {0, plural, one {# person} other {# people}}"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:61
#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:63
msgid "Shared with me"
msgstr "Shared with me"

#: packages/webapp/src/analytics/components/TablePaginator/TablePaginator.tsx:94
msgid "Show <0>{pageSize}</0>"
msgstr "Show <0>{pageSize}</0>"

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResults.tsx:61
msgid "Showing {0, plural, one {# result} other {# results}}"
msgstr "Showing {0, plural, one {# result} other {# results}}"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:54
msgid "Sign in"
msgstr "Sign in"

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:127
msgid "Sign up<0>for free</0>"
msgstr "Sign up<0>for free</0>"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:34
msgid "Simplify scheduling with AI. Share this unique link with others to schedule a time to meet based on availability and predicted engagement."
msgstr "Simplify scheduling with AI. Share this unique link with others to schedule a time to meet based on availability and predicted engagement."

#: packages/webapp/src/analytics/constants/topics.ts:60
msgid "Slack channel"
msgstr "Slack channel"

#: packages/webapp/src/analytics/constants/topics.ts:61
msgid "Slack channels"
msgstr "Slack channels"

#: packages/webapp/src/analytics/constants/topics.ts:113
msgid "Slack message"
msgstr "Slack message"

#: packages/webapp/src/analytics/constants/topics.ts:114
msgid "Slack messages"
msgstr "Slack messages"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:37
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:60
#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:71
msgid "Smart Scheduler"
msgstr "Smart Scheduler"

#: packages/webapp/src/analytics/components/SideNav/SchedulingLink.tsx:183
msgid "Smart Scheduler Link"
msgstr "Smart Scheduler Link"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:196
msgid "Something went wrong and your feedback could not be saved. Please refresh the page or try again later."
msgstr "Something went wrong and your feedback could not be saved. Please refresh the page or try again later."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:155
msgid "Something went wrong changing your info. Please try again later"
msgstr "Something went wrong changing your info. Please try again later"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:202
msgid "Something went wrong sending a password reset email. Please try again later."
msgstr "Something went wrong sending a password reset email. Please try again later."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:185
msgid "Something went wrong updating your email. Please check that you've entered a valid email."
msgstr "Something went wrong updating your email. Please check that you've entered a valid email."

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:54
msgid "Something went wrong. Please refresh the app and try again."
msgstr "Something went wrong. Please refresh the app and try again."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:179
msgid "Sorry, an account with that email address already exists."
msgstr "Sorry, an account with that email address already exists."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:92
msgid "Sorry, that account is already associated with an existing Read account."
msgstr "Sorry, that account is already associated with an existing Read account."

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:197
msgid "Sorry, there was a problem accepting the recommendation."
msgstr "Sorry, there was a problem accepting the recommendation."

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:256
msgid "Sorry, there was a problem ignoring all recommendations"
msgstr "Sorry, there was a problem ignoring all recommendations"

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:196
msgid "Sorry, this recommendation is no longer applicable. Please ignore the recommendation to continue."
msgstr "Sorry, this recommendation is no longer applicable. Please ignore the recommendation to continue."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:93
msgid "Sorry, we couldn't connect your account. Please try again or contact support."
msgstr "Sorry, we couldn't connect your account. Please try again or contact support."

#: packages/webapp/src/analytics/MeetingReports/SearchResults/NoResults.tsx:16
msgid "Sorry, we couldn't find any results for <0>{query}</0>"
msgstr "Sorry, we couldn't find any results for <0>{query}</0>"

#: packages/webapp/src/analytics/account/WorkspaceSettings/WorkspaceJoin.tsx:125
msgid "Sorry! This Workspace is currently full. Please reach out to the Workspace owner to add additional seats."
msgstr "Sorry! This Workspace is currently full. Please reach out to the Workspace owner to add additional seats."

#: packages/webapp/src/analytics/MeetingReports/SearchResults/SearchResultSortMenu.tsx:70
msgid "Sorted by {0}"
msgstr "Sorted by {0}"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:36
#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/SourceFilterMenu.tsx:64
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:23
msgid "Source"
msgstr "Source"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:90
msgid "Sources ({totalNumSources})"
msgstr "Sources ({totalNumSources})"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:171
msgid "SSO & SAML"
msgstr "SSO & SAML"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:52
msgid "SSO sign up option"
msgstr "SSO sign up option"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:61
msgid "Status"
msgstr "Status"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:91
msgid "Step {step} of {NUM_VISIBLE_STEPS}:"
msgstr "Step {step} of {NUM_VISIBLE_STEPS}:"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:112
msgid "Subtotal"
msgstr "Subtotal"

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:133
msgid "Success, you may now accept recommendations!"
msgstr "Success, you may now accept recommendations!"

#: packages/webapp/src/analytics/account/WorkspaceSettings/WorkspaceJoin.tsx:145
msgid "Success! You have joined the {0} Workspace."
msgstr "Success! You have joined the {0} Workspace."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:33
msgid "Success! Your credits have been added to your account."
msgstr "Success! Your credits have been added to your account."

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:151
msgid "Successfully changed your info!"
msgstr "Successfully changed your info!"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:26
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:49
msgid "Summary, transcription with audience reactions, action items, key questions, and topics."
msgstr "Summary, transcription with audience reactions, action items, key questions, and topics."

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:127
msgid "Support"
msgstr "Support"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:30
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:53
msgid "Support for Zoom, Google Meet, Microsoft Teams, and Webex"
msgstr "Support for Zoom, Google Meet, Microsoft Teams, and Webex"

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/TagFilterMenu.tsx:92
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingReportTagsCell.tsx:130
msgid "Tag"
msgstr "Tag"

#: packages/webapp/src/analytics/account/UserPreferences/tabConfig.ts:78
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTable.tsx:44
msgid "Tags"
msgstr "Tags"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/ManageMeetingReportTags.tsx:82
msgid "Tags ({0})"
msgstr "Tags ({0})"

#: packages/webapp/src/analytics/WorkspaceOverview/Participation/ParticipationTable.tsx:42
msgid "Team"
msgstr "Team"

#: packages/webapp/src/analytics/constants/topics.ts:48
msgid "Teams channel"
msgstr "Teams channel"

#: packages/webapp/src/analytics/constants/topics.ts:49
msgid "Teams channels"
msgstr "Teams channels"

#: packages/webapp/src/analytics/constants/topics.ts:102
msgid "Teams message"
msgstr "Teams message"

#: packages/webapp/src/analytics/constants/topics.ts:103
msgid "Teams messages"
msgstr "Teams messages"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:343
msgid "Thanks for your feedback 🙂"
msgstr "Thanks for your feedback 🙂"

#: packages/webapp/src/analytics/auth/utils.tsx:38
msgid "The administrator of this domain has restricted account creation. Contact your administrator to request a Read Workspace invitation, or create an account with a different domain."
msgstr "The administrator of this domain has restricted account creation. Contact your administrator to request a Read Workspace invitation, or create an account with a different domain."

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:41
msgid "The Daily Read you are trying to view cannot be accessed at this time. Please try again later or reach out to <0>support@read.ai</0> if the problem persists."
msgstr "The Daily Read you are trying to view cannot be accessed at this time. Please try again later or reach out to <0>support@read.ai</0> if the problem persists."

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:307
msgid "The text-to-speech voice you are hearing is AI-generated and not a human voice."
msgstr "The text-to-speech voice you are hearing is AI-generated and not a human voice."

#: packages/webapp/src/analytics/auth/utils.tsx:51
msgid "There is already an account for this email address. Please sign in or create an account with a different email address."
msgstr "There is already an account for this email address. Please sign in or create an account with a different email address."

#: packages/webapp/src/analytics/Recommendations/Recommendations.tsx:136
msgid "There was a problem obtaining edit access to your calendar."
msgstr "There was a problem obtaining edit access to your calendar."

#: packages/webapp/src/analytics/components/SideNav/SideNavAddRead.tsx:113
msgid "There was an error adding Read. <0>Retry</0> or <1>troubleshoot</1>."
msgstr "There was an error adding Read. <0>Retry</0> or <1>troubleshoot</1>."

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:113
msgid "There was an error removing your payment method. Please refresh the page or try again later."
msgstr "There was an error removing your payment method. Please refresh the page or try again later."

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:31
msgid "These are credits that you've purchased, in addition to your monthly credits."
msgstr "These are credits that you've purchased, in addition to your monthly credits."

#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/RecordingCappedBanner.tsx:26
msgid "This meeting exceeds the recording duration of {recordingMinutes} minutes per meeting on the {0} plan. Only the first {recordingMinutes} minutes were recorded by Read."
msgstr "This meeting exceeds the recording duration of {recordingMinutes} minutes per meeting on the {0} plan. Only the first {recordingMinutes} minutes were recorded by Read."

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:100
msgid "This process can take as long as 24 hours, depending on the size of the upload."
msgstr "This process can take as long as 24 hours, depending on the size of the upload."

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:115
msgid "This Readout was automatically generated from a {sourceLabel} {0}"
msgstr "This Readout was automatically generated from a {sourceLabel} {0}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:121
msgid "This will automatically be applied to your next payment."
msgstr "This will automatically be applied to your next payment."

#: packages/webapp/src/analytics/account/WorkspaceSettings/WorkspaceJoin.tsx:166
msgid "This Workspace invite is no longer valid."
msgstr "This Workspace invite is no longer valid."

#: packages/webapp/src/analytics/constants/topics.ts:30
#: packages/webapp/src/analytics/constants/topics.ts:41
msgid "thread"
msgstr "thread"

#: packages/webapp/src/analytics/constants/topics.ts:31
#: packages/webapp/src/analytics/constants/topics.ts:42
msgid "threads"
msgstr "threads"

#: packages/webapp/src/analytics/auth/SignupCard/SignupCard.tsx:133
msgid "To accept your Workspace invitation, please create a Read account."
msgstr "To accept your Workspace invitation, please create a Read account."

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:100
msgid "To access Read's full features, including Read Score, Sentiment, and Transcription, Zoom requires that a recording notification is sent to meeting participants."
msgstr "To access Read's full features, including Read Score, Sentiment, and Transcription, Zoom requires that a recording notification is sent to meeting participants."

#: packages/webapp/src/analytics/components/DateSelector/utils.ts:13
msgid "Today"
msgstr "Today"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:37
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:38
#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicTitleCell.tsx:39
msgid "Topic"
msgstr "Topic"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:79
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:106
msgid "Topic progression"
msgstr "Topic progression"

#: packages/webapp/src/analytics/TopicReport/TopicReportHeader/Download/DownloadLink.tsx:66
msgid "Topic summary"
msgstr "Topic summary"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:43
msgid "Topics & What You Missed"
msgstr "Topics & What You Missed"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ForYouTeaser.tsx:75
msgid "Topics For You"
msgstr "Topics For You"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:258
msgid "Total due on {formattedPeriodEnd} (next billing period)"
msgstr "Total due on {formattedPeriodEnd} (next billing period)"

#: packages/webapp/src/analytics/account/Billing/checkout/BillingSubscriptionCheckout/BillingSubscriptionCheckoutBreakdown.tsx:141
msgid "Total{0}"
msgstr "Total{0}"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:69
msgid "Transcription augmented with reactions"
msgstr "Transcription augmented with reactions"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:119
msgid "trial"
msgstr "trial"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:99
msgid "Try expanding the date range, or add Read to an upcoming meeting."
msgstr "Try expanding the date range, or add Read to an upcoming meeting."

#: packages/webapp/src/analytics/MeetingReports/SearchResults/NoResults.tsx:21
msgid "Try searching with another term, or return to <0>all Meeting Reports</0>"
msgstr "Try searching with another term, or return to <0>all Meeting Reports</0>"

#: packages/webapp/src/analytics/account/WorkspaceSettings/WorkspaceJoin.tsx:129
msgid "Unable to join Workspace. Please refresh the page or try again later."
msgstr "Unable to join Workspace. Please refresh the page or try again later."

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/TopicReportTableRow/TopicReportTableRow.tsx:57
msgid "Unable to remove report. Please refresh the page or try again."
msgstr "Unable to remove report. Please refresh the page or try again."

#: packages/webapp/src/analytics/WorkspaceOverview/Participation/ParticipationTable.tsx:53
msgid "Unbalanced Meetings"
msgstr "Unbalanced Meetings"

#: packages/webapp/src/analytics/ReportFileDownload/ReportFileDownload.tsx:29
msgid "Unknown file"
msgstr "Unknown file"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:182
msgid "Unlimited meeting duration"
msgstr "Unlimited meeting duration"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:72
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:99
msgid "Unlimited meeting reports"
msgstr "Unlimited meeting reports"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:111
msgid "Unlimited meetings"
msgstr "Unlimited meetings"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:73
msgid "Upcoming Plan"
msgstr "Upcoming Plan"

#: packages/webapp/src/analytics/account/Billing/BillingManage/PaymentMethod/PaymentMethod.tsx:54
msgid "Update payment method"
msgstr "Update payment method"

#: packages/webapp/src/analytics/components/reports/RenameReportModal.tsx:37
msgid "Update the name of this report below. Everyone with report access can see this change."
msgstr "Update the name of this report below. Everyone with report access can see this change."

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:58
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:98
#: packages/webapp/src/analytics/account/Billing/utils.ts:208
#: packages/webapp/src/analytics/account/WorkspaceSettings/Settings/AdvancedModule.tsx:47
#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/ReportExpirationBanner.tsx:65
#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:124
msgid "Upgrade"
msgstr "Upgrade"

#: packages/webapp/src/analytics/MeetingReport/MeetingReportBanners/ReportExpirationBanner.tsx:80
msgid "Upgrade for unlimited. Report cannot be generated after 30 days ({formattedExpirationDate})."
msgstr "Upgrade for unlimited. Report cannot be generated after 30 days ({formattedExpirationDate})."

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:177
msgid "Upgrade now"
msgstr "Upgrade now"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:148
msgid "Upgrade plan"
msgstr "Upgrade plan"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseMaximumAlert.tsx:52
msgid "Upgrade Plan"
msgstr "Upgrade Plan"

#: packages/webapp/src/analytics/TutorialsAndPopups/EduPopup.tsx:152
msgid "Upgrade to EDU"
msgstr "Upgrade to EDU"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:156
msgid "Upgrade to generate a report"
msgstr "Upgrade to generate a report"

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:161
msgid "Upgrade to Read Pro or Enterprise to access For You insights, unlimited meeting reports, and more."
msgstr "Upgrade to Read Pro or Enterprise to access For You insights, unlimited meeting reports, and more."

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:30
msgid "Upgrade to Read Pro or Enterprise to get free monthly credits"
msgstr "Upgrade to Read Pro or Enterprise to get free monthly credits"

#: packages/webapp/src/analytics/MeetingReports/MeetingReportsTabs.tsx:156
msgid "Upload"
msgstr "Upload"

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:50
msgid "Upload video files from your device to generate Read Meeting Reports. Each minute of video requires 1 credit."
msgstr "Upload video files from your device to generate Read Meeting Reports. Each minute of video requires 1 credit."

#: packages/webapp/src/analytics/MeetingReports/ReportsMenu/SourceFilterMenu.tsx:110
msgid "Uploaded Report"
msgstr "Uploaded Report"

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:131
msgid "Uploading videos to Read"
msgstr "Uploading videos to Read"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:195
msgid "USD. Per license, billed annually."
msgstr "USD. Per license, billed annually."

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/PlanDetail.tsx:199
msgid "USD. Per license, billed monthly."
msgstr "USD. Per license, billed monthly."

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:29
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:52
msgid "Video conferencing"
msgstr "Video conferencing"

#: packages/webapp/src/analytics/auth/AuthLanding/AuthLanding.tsx:74
msgid "Video playback with AI highlights"
msgstr "Video playback with AI highlights"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:120
msgid "Video playback, prioritized support, and controls for scale with unlimited meetings."
msgstr "Video playback, prioritized support, and controls for scale with unlimited meetings."

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:65
msgid "video upload credits"
msgstr "video upload credits"

#: packages/webapp/src/analytics/account/Billing/BillingManage/VideoUploadCredits.tsx:60
msgid "Video Upload Credits"
msgstr "Video Upload Credits"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:93
msgid "View all"
msgstr "View all"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/styles.tsx:109
msgid "View all features"
msgstr "View all features"

#: packages/webapp/src/analytics/WorkspaceOverview/MeetingManager/MeetingManager.tsx:144
msgid "View all Meeting Reports"
msgstr "View all Meeting Reports"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:156
msgid "View all Read plans"
msgstr "View all Read plans"

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:147
msgid "View Desktop Site"
msgstr "View Desktop Site"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:186
msgid "View fewer"
msgstr "View fewer"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ForYouTeaser.tsx:39
msgid "View For You"
msgstr "View For You"

#: packages/webapp/src/analytics/TopicReport/TopicReportSidebar/TopicReportSidebarOverview.tsx:188
msgid "View more"
msgstr "View more"

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteMeetingReportsEmptyState.tsx:52
msgid "View my meetings"
msgstr "View my meetings"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatus.tsx:49
msgid "View Readout"
msgstr "View Readout"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:250
msgid "View transcript"
msgstr "View transcript"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/ReportsTableEmptyState.tsx:68
msgid "View upcoming meetings"
msgstr "View upcoming meetings"

#: packages/webapp/src/analytics/components/DailyReadPlayer/DailyReadPlayer.tsx:324
msgid "Was this Daily Read accurate?"
msgstr "Was this Daily Read accurate?"

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/ReadoutStatusContent.tsx:76
msgid "We couldn't generate a Readout from {0}. This may be due to limited emails or using an unsupported language. For more details, please check our <0>support article</0>."
msgstr "We couldn't generate a Readout from {0}. This may be due to limited emails or using an unsupported language. For more details, please check our <0>support article</0>."

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:171
msgid "Welcome to {0}"
msgstr "Welcome to {0}"

#: packages/webapp/src/analytics/MeetingReports/MeetingTipsBanner.tsx:31
msgid "When a conference room is detected during a meeting, your attendance defaults to <0/>(conference room)."
msgstr "When a conference room is detected during a meeting, your attendance defaults to <0/>(conference room)."

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:63
msgid "When you downgrade to a Free Plan, you will lose access to features such as:"
msgstr "When you downgrade to a Free Plan, you will lose access to features such as:"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:76
msgid "With recording enabled, get access to a full transcript and playback, plus detailed meeting metrics."
msgstr "With recording enabled, get access to a full transcript and playback, plus detailed meeting metrics."

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/DowngradeModal.tsx:15
msgid "Workspace benchmarks, branding, and permissions"
msgstr "Workspace benchmarks, branding, and permissions"

#: packages/webapp/src/analytics/components/SideNav/WorkspaceInviteLink.tsx:17
msgid "Workspace Invitation!"
msgstr "Workspace Invitation!"

#: packages/webapp/src/analytics/components/SideNav/constants.ts:127
msgid "Workspace Overview"
msgstr "Workspace Overview"

#. js-lingui-explicit-id
#: packages/webapp/src/analytics/WorkspaceOverview/WorkspaceOverview.tsx:36
msgid "Workspace Overview"
msgstr "Workspace Overview"

#: packages/webapp/src/analytics/components/UserNavMenu.tsx:107
msgid "Workspace Settings"
msgstr "Workspace Settings"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:75
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:102
#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:87
msgid "Workspaces"
msgstr "Workspaces"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:278
msgid "year"
msgstr "year"

#: packages/webapp/src/analytics/account/components/FreeTrialAlert.tsx:96
msgid "You are currently on a free trial of the {0} Plan."
msgstr "You are currently on a free trial of the {0} Plan."

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:62
msgid "You are on the {0} {1, select, true {trial} other {plan}}, which does not include free credits per month. You can purchase credits any time on the <0>billing page</0>."
msgstr "You are on the {0} {1, select, true {trial} other {plan}}, which does not include free credits per month. You can purchase credits any time on the <0>billing page</0>."

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:74
msgid "You are on the {0} {1, select, true {trial} other {plan}}, which includes {2} free credits each month! Additional credits can be purchased any time."
msgstr "You are on the {0} {1, select, true {trial} other {plan}}, which includes {2} free credits each month! Additional credits can be purchased any time."

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:40
msgid "You can count on me to provide real-time meeting measurement, personalized meeting analytics, and coaching. <0>Watch the short video above to learn more!</0>"
msgstr "You can count on me to provide real-time meeting measurement, personalized meeting analytics, and coaching. <0>Watch the short video above to learn more!</0>"

#: packages/webapp/src/analytics/TutorialsAndPopups/UploadTutorial.tsx:57
msgid "You can purchase credits any time on the <0>billing page</0>."
msgstr "You can purchase credits any time on the <0>billing page</0>."

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:99
msgid "You cannot purchase an EDU plan while you are in a workspace"
msgstr "You cannot purchase an EDU plan while you are in a workspace"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:378
msgid "You cannot update your email on an EDU plan"
msgstr "You cannot update your email on an EDU plan"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:380
msgid "You cannot update your email on your current plan"
msgstr "You cannot update your email on your current plan"

#: packages/webapp/src/analytics/account/Billing/BillingManage/LicenseUsage/RemoveLicensesModal.tsx:148
msgid "You currently have <0>{maxRemovableLicenses, plural, one {# unused license} other {# unused licenses}}</0> {0} that can be removed.{1}"
msgstr "You currently have <0>{maxRemovableLicenses, plural, one {# unused license} other {# unused licenses}}</0> {0} that can be removed.{1}"

#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:61
#: packages/webapp/src/analytics/DailyRead/DailyRead.tsx:143
msgid "You didn't have enough meeting data to generate a Daily Read today 🙁 <0>Add Read</0> to more meetings and check back tomorrow."
msgstr "You didn't have enough meeting data to generate a Daily Read today 🙁 <0>Add Read</0> to more meetings and check back tomorrow."

#: packages/webapp/src/analytics/components/RollupFilter/RollupFilter.tsx:111
msgid "You do not have permission to view all team reports for {0}. Read is now showing just your meetings."
msgstr "You do not have permission to view all team reports for {0}. Read is now showing just your meetings."

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingHistory.tsx:98
msgid "You don't have any invoices yet"
msgstr "You don't have any invoices yet"

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/CurrentPlan.tsx:115
msgid "You have {0} in credits."
msgstr "You have {0} in credits."

#: packages/webapp/src/analytics/account/WorkspaceSettings/WorkspaceJoin.tsx:101
msgid "You have {0} the invite to the {1} Workspace."
msgstr "You have {0} the invite to the {1} Workspace."

#: packages/webapp/src/analytics/account/Billing/BillingManage/CurrentPlan/ReactivatePlanButton.tsx:39
msgid "You must add a payment method before reactivating your plan"
msgstr "You must add a payment method before reactivating your plan"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:97
msgid "You must have a verified EDU email to purchase this plan"
msgstr "You must have a verified EDU email to purchase this plan"

#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:122
#: packages/webapp/src/analytics/TutorialsAndPopups/FirstTimeTutorial/Content.tsx:160
msgid "You now have access to:"
msgstr "You now have access to:"

#: packages/webapp/src/embedded/zoom/ZoomRecordingPrompt.tsx:132
msgid "You're on the {0} plan, which includes {maxMonthlyPremiumReports} premium reports (full metrics and transcription) per month. Upgrade to receive unlimited premium reports."
msgstr "You're on the {0} plan, which includes {maxMonthlyPremiumReports} premium reports (full metrics and transcription) per month. Upgrade to receive unlimited premium reports."

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:154
msgid "You're on the <0>{0} plan.</0>"
msgstr "You're on the <0>{0} plan.</0>"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:137
msgid "You're on the <0>{0} plan</0>, which includes {reportQuota} premium reports (full metrics and transcription) per month. Your count resets {formattedDate}."
msgstr "You're on the <0>{0} plan</0>, which includes {reportQuota} premium reports (full metrics and transcription) per month. Your count resets {formattedDate}."

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:190
msgid "You're on the <0>{0} plan</0>, which includes unlimited premium reports{1}"
msgstr "You're on the <0>{0} plan</0>, which includes unlimited premium reports{1}"

#: packages/webapp/src/analytics/account/Billing/BillingPlanCompare/BillingPlanCompare.tsx:113
msgid "You're on the <0>{0}</0>"
msgstr "You're on the <0>{0}</0>"

#: packages/webapp/src/embedded/Dashboard/components/OutOfQuota.tsx:114
msgid "You're out of free reports for the month{0}. Upgrade to Read Pro or Enterprise for more."
msgstr "You're out of free reports for the month{0}. Upgrade to Read Pro or Enterprise for more."

#: packages/webapp/src/analytics/MeetingReports/components/SearchResult/SearchResult.tsx:184
msgid "You're the report owner"
msgstr "You're the report owner"

#: packages/webapp/src/analytics/MeetingReports/Reports.tsx:81
msgid "Your {0} account was successfully connected"
msgstr "Your {0} account was successfully connected"

#: packages/webapp/src/analytics/account/Billing/utils.ts:412
msgid "Your {0} plan will start immediately after payment. {1}."
msgstr "Your {0} plan will start immediately after payment. {1}."

#: packages/webapp/src/analytics/MeetingReports/Reports.tsx:165
msgid "Your account has been successfully upgraded to {0} ({1}). Past reports will be generated shortly. This process can take up to 24 hours."
msgstr "Your account has been successfully upgraded to {0} ({1}). Past reports will be generated shortly. This process can take up to 24 hours."

#: packages/webapp/src/analytics/MeetingReports/Reports.tsx:78
msgid "Your account was successfully connected"
msgstr "Your account was successfully connected"

#: packages/webapp/src/analytics/account/UserPreferences/AccountModule/AccountModule.tsx:88
msgid "Your account was successfully connected!"
msgstr "Your account was successfully connected!"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:44
msgid "Your billing information has been successfully updated."
msgstr "Your billing information has been successfully updated."

#: packages/webapp/src/analytics/Pulse/PulseUpsell.tsx:52
msgid "Your Daily Read podcast offers a concise overview of the past 24 hours and prepares you for upcoming meetings. Perfect for catching up on your daily commute."
msgstr "Your Daily Read podcast offers a concise overview of the past 24 hours and prepares you for upcoming meetings. Perfect for catching up on your daily commute."

#: packages/webapp/src/analytics/account/UserPreferences/UserPreferences.tsx:63
msgid "Your email address has not been verified. Please click the magic link in your inbox to verify your email."
msgstr "Your email address has not been verified. Please click the magic link in your inbox to verify your email."

#: packages/webapp/src/analytics/MeetingReports/ReportStatusesAndUpsells/ReadoutStatus/utils.ts:21
msgid "Your first {0} Readout is ready!"
msgstr "Your first {0} Readout is ready!"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/utils.ts:149
msgid "Your first Readout"
msgstr "Your first Readout"

#: packages/webapp/src/analytics/account/Billing/utils.ts:286
msgid "Your plan will automatically be downgraded to {0} on {formattedPlanChangeDate}"
msgstr "Your plan will automatically be downgraded to {0} on {formattedPlanChangeDate}"

#: packages/webapp/src/analytics/account/Billing/utils.ts:296
msgid "Your plan will automatically be downgraded to the {0} free trial on {formattedPlanChangeDate}"
msgstr "Your plan will automatically be downgraded to the {0} free trial on {formattedPlanChangeDate}"

#: packages/webapp/src/analytics/account/Billing/utils.ts:418
msgid "Your plan will automatically change to {0} next billing period. {1}."
msgstr "Your plan will automatically change to {0} next billing period. {1}."

#: packages/webapp/src/analytics/account/Billing/utils.ts:304
msgid "Your plan will automatically switch to {0} (billed {1}) on {formattedPlanChangeDate}"
msgstr "Your plan will automatically switch to {0} (billed {1}) on {formattedPlanChangeDate}"

#: packages/webapp/src/analytics/account/Billing/BillingManage/BillingUpdateStatusBanner.tsx:21
msgid "Your Read plan has been successfully updated."
msgstr "Your Read plan has been successfully updated."

#: packages/webapp/src/analytics/MeetingReports/IncompleteMeetingReports/IncompleteReportsTable.tsx:52
msgid "Your role"
msgstr "Your role"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:84
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:111
msgid "Zapier, Slack, and Webhooks"
msgstr "Zapier, Slack, and Webhooks"

#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:34
#: packages/webapp/src/analytics/account/Billing/__tests__/utils.test.ts:330
msgid "Zoom"
msgstr "Zoom"

#: packages/webapp/src/analytics/account/Billing/constants.ts:24
msgid "Zoom Apps"
msgstr "Zoom Apps"

#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:69
#: packages/webapp/src/analytics/account/Billing/components/PlanDetail/constants.ts:96
msgid "Zoom features, plus:"
msgstr "Zoom features, plus:"

#: packages/webapp/src/analytics/MeetingReports/ReportsTable/MeetingReportTableRow/MeetingTitleCell.tsx:146
msgid "Zoom meeting access is disabled"
msgstr "Zoom meeting access is disabled"
